import { render, staticRenderFns } from "./MainSlides.vue?vue&type=template&id=0e48790e&scoped=true&"
import script from "./MainSlides.vue?vue&type=script&lang=js&"
export * from "./MainSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48790e",
  null
  
)

export default component.exports